export default {
  copy: {
    en: '© Scentbird',
    es: '© Scentbird',
  },
}
